import { AnalyticsPayload } from '@play-co/replicant/lib/core/common/Analytics';
import { ReplicantPlatformMessagePayloadEncoderAPI } from '@play-co/replicant';

/**
 * This encoder for chatbot(OA) messages payload
 * We need that to able to encode messages on server side
 *
 * We should keep it similar to encodePayload!!
 *
 **/
export async function encodeReplicantMessagePayload(
  payload: AnalyticsPayload & {
    payload?: {
      forceReload?: boolean;
    };
  },
  api: ReplicantPlatformMessagePayloadEncoderAPI,
): Promise<AnalyticsPayload> {
  // In this example, we "encode" by sending the original payload to replicant's own KV storage.
  // A decoder could fetch from the same storage using the $key prop of the encoded payload.
  const $key = [
    api.date.now(),
    api.math.random().toString(36).substring(2, 10),
  ].join('-');

  await api.kvStore.send($key, JSON.stringify(payload));

  return {
    $key,
    $channel: payload.$channel,
    feature: payload.feature,
    ...(payload?.payload?.forceReload
      ? {
          payload: {
            forceReload: payload?.payload?.forceReload,
          },
        }
      : undefined),
    $subFeature: payload.$subFeature,
    playerID: payload.playerID,
  };
}
